module.exports = __webpack_public_path__ + "media/images/shared/icon-background-check-white-a1d1be512c69ced9e840e5e16aed3706.png";